
export const paymentsTypes = [
	"pago con tarjeta, verificado por conekta",
	"pago con tarjeta, verificado por stripe",
	"verificado por webhook Conekta oxxo y spei",
];
